/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRAProcessLocale
 */
export interface CRAProcessLocale {
}

/**
 * Check if a given object implements the CRAProcessLocale interface.
 */
export function instanceOfCRAProcessLocale(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRAProcessLocaleFromJSON(json: any): CRAProcessLocale {
    return CRAProcessLocaleFromJSONTyped(json, false);
}

export function CRAProcessLocaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRAProcessLocale {
    return json;
}

export function CRAProcessLocaleToJSON(value?: CRAProcessLocale | null): any {
    return value;
}

